import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ic_keyboard_arrow_right_48px" clipPath="url(#clip0_76_6637)">
        <path
          id="Vector"
          d="M15.4141 16.46L10.8291 11.875L15.4141 7.29L13.9991 5.875L7.99906 11.875L13.9991 17.875L15.4141 16.46Z"
          fill="#333739"
        />
      </g>
      <defs>
        <clipPath id="clip0_76_6637">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
